import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { useTab } from "@mui/base";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../Icons/Icons";
import { useNavigate } from "react-router-dom";

import {
  deleteCustomRequest,
  getCustomRequest,
  updateCustomRequest,
} from "../../../services/Store/Actions/fastagAction";
import { getUserLogs, updateUserLogs } from "../../../services/Store/Actions/appActions";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AdsClickIcon from '@mui/icons-material/AdsClick';


function Notifications(props) {
  const { toggle, modal, setModal, regNo, title, logId } = props;
  const [requestType, setrequestType] = useState(0);
  const { customRequest } = useSelector((state) => state.fastag);
  console.log("customRequestcustomRequest", customRequest);
  const dispatch = useDispatch();
  const [type, setType] = useState("");
  const [loader, setLoader] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);
  const { userLogs } = useSelector((state) => state?.app);
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  console.log("userLogssasassuserLogssssss", userLogs);

  const handleClose = () => {
    setModal(false);
  };
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      getUserLogs({}, (res) => {
        console.log("userLogsdispatchdispatch", res);
      })
    );
    setSelectedNotifications([])
  }, [modal]);
  useEffect(() => {
    return function cleanUp() {};
  }, []);
  // const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  
  const handleCheckboxClick = (logId) => {
    let temp = [...selectedNotifications];
    console.log("shjk",temp)
    const index = temp.indexOf(logId);
    console.log("index",index,logId)
    if (index !== -1) {
      temp.splice(index, 1); // Remove logId if already selected
    } else {
      temp.push(logId); // Add logId if not selected
    }
    setSelectedNotifications(temp);
  };
  const handleSelectAll = () => {
    if (!selectAll) {
      const allLogIds = userLogs?.data.map((item) => item.logId);
      setSelectedNotifications(allLogIds);
    } else {
      setSelectedNotifications([]);
    }
    setSelectAll(!selectAll);
  };

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
        style={{
          textAlign: 'center'
        }}
      >
        <ModalBody
          className="transactionModalBody"
          style={{
           
          }}
        >
          <div>
            <div className="closeBtnWithBackground mb-10" onClick={handleClose}>
              <SvgImage
                classname="close-btn-text"
                style={{ width: "10%", height: "10%" }}
                name="crossBtnWIthBackground"
                width="20%"
                height="20%"
              />
            </div>
            <div
              style={{ marginTop: " 10px" }}
              className="row"
              //   className="PGCollectionBox"
            >
              <div className="showroomText col-12">Notifications</div>
            </div>
          </div>

          <div
              className="row"
              style={{
                marginTop: "10px",
                borderRadius: "5px",
                padding: "5px",
              }}
            >
              <div
                className="col-1"
                style={{
                  alignContent: "center",
                  justifyContent: "center",
                  justifySelf: "center",
                  alignSelf: "center",
                }}         
              >
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
              </div>
              <div
                className="col-11"
                style={{
                  textAlign: "left",
                }}
              >
                <a
                  style={{
                    borderWidth: "1px",
                    textAlign: "center",
                  }}
                  onClick={()=>{}}
                >
                  {"select all"}
                </a>
              </div>
            </div>



          

          {userLogs?.data.map((item, index) => {
            const isSelected = selectedNotifications.includes(item?.logId);

            return (
              <div
              key={index}
              className="row"
              style={{
                marginTop: "10px",
                backgroundColor: isSelected ? "#D9FCD2" : "#f4ceb8",
                borderRadius: "5px",
                padding: "5px",
              }}
             
            >
              <div
                className="col-1 h-full"
                style={{
                  alignContent: "center",
                  justifyContent: "center",
                  justifySelf: "center",
                  alignSelf: "center",
                  height:"40px"

                }}
                onClick={() => handleCheckboxClick(item.logId)}
              >
                <input
                  type="checkbox"
                  checked={selectedNotifications.includes(item.logId)}
                  
                  
                onChange={() => handleCheckboxClick(item.logId)}
                />
              </div>
              <div
                className="col-11"
                style={{
                  textAlign: "left",
                }}
                onClick={()=>{
                  console.log("clickedddd",item)
                  if(item?.deeplink){
                  if(window.location?.pathname?.includes("/trips/")){
                      navigate(item.deeplink)
                      window.location.reload()
                    }
                    else{
                      navigate(item.deeplink)
                    }
                    handleClose()
                  }else{
                    console.log("jierj0ijfer",window.location)
                    handleClose()
                    navigate('/Trips')
                  }
                }}
              >
                <a
                  style={{
                    borderWidth: "1px",
                    textAlign: "center",
                  }}
                  onClick={()=>{}}
                >
                  {item.message}
                </a>
              </div>
            </div>
            );
          })}

          <Button
            style={{ width: "70%",marginTop:'15px' }}
            className="generateOtp text3 Medium btn btn-secondary"
            onClick={()=>{
              dispatch(updateUserLogs({
                logs:selectedNotifications
              },(res)=>{
                console.log("resss",res)
                dispatch(
                  getUserLogs({}, (res) => {
                    console.log("userLogsdispatchdispatch", res);
                  }))
                
              }))
              console.log("selectedNotificationsselectedNotifications",selectedNotifications)
            }}
          >
            Mark As Read
          </Button>
        </ModalBody>
      </Modal>
      {/* <CreateInvoice
        toggle={createInvoice}
        modal={invoiceModal}
        setModal={setInvoiceModal}
        customerId={customerId}
        isCheckAll={isCheckAll}
        setIsCheckAll={setIsCheckAll}
        isCheck={isCheck}
        setIsCheck={setIsCheck}
        customer={customer}
      />
      <AddInvoice
        toggle={addInvoiceFunc}
        modal={addInvoice}
        setModal={setAddInvoice}
      /> */}
    </div>
  );
}

export default Notifications;
